
import { Col, Row, Container, Button } from "react-bootstrap";

function FinalPage() {
  return (
    <div className="flex-container">
        <div className="background-image" style={{ backgroundImage: `url(/images/background-1.png)` }}>
        <Container>
        <Row className="justify-content-md-center title-row">
            <Col>
                <p style={{ fontSize: "16pt", textAlign: "center", padding: "20px", color: "#256143" }}>
                    感謝大家參與這次的測驗小遊戲！本活動透過趣味化的人格分析，搭配對應的保險推薦，讓大家更認識自己在風險上的可能特質。不過，測驗結果僅供參考，若您對自己的性格探索更感興趣，建議可進一步體驗完整版 MBTI 測驗。同時，若您對保險有更多規劃需求，也歡迎洽詢國泰人壽的專業顧問，獲得量身打造的建議。
                </p>
            </Col>
        </Row>
        <Row className="justify-content-md-center">
            <Col>
                <img src="/images/final-cover.png" className="explorer" alt="explorer" />
            </Col>
        </Row>
        <Row className="justify-content-md-center">
            <Col>
                <Button sryle={{ backgroundColor: "#256143", borderColor: "#256143" }} className="start-button" variant="primary" size="lg">
                    <a href="https://www.cathaylife.com.tw/cathaylife/" target="_blank" rel="noopener noreferrer" style={{ color: "white", textDecoration: "none" }}>
                        探索更多保險
                    </a>
                </Button>
            </Col>
        </Row>
      </Container>
      </div>
    </div>
  );
}

export default FinalPage;